<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [showHeader]="false"
  [closeOnEscape]="true"
  (onHide)="onHide()"
  styleClass="command-palette-dialog"
  [contentStyle]="{ padding: '0', 'border-radius': '12px' }"
  maskStyleClass="command-palette-mask">
  <div class="command-palette-container flex flex-column">
    <!-- Header / Search -->
    <div class="search-section p-3 border-bottom-1 surface-border flex align-items-center gap-2">
      <lucide-icon
        name="search"
        class="text-500"
        [size]="20"></lucide-icon>
      <input
        #searchInput
        type="text"
        pInputText
        class="flex-1 w-full border-none shadow-none text-lg p-0 bg-transparent text-color"
        placeholder="Digite um comando ou ação..."
        [ngModel]="searchQuery()"
        (ngModelChange)="searchQuery.set($event); selectedIndex.set(0)"
        (keydown)="onKeyDown($event)"
        autocomplete="off" />

      <span class="text-xs p-1 surface-100 border-round text-500 font-medium">ESC</span>
    </div>

    <!-- Results List -->
    <div
      class="results-list overflow-y-auto"
      style="max-height: 400px">
      @if (filteredCommands().length > 0) {
      <div class="flex flex-column p-2 bg-white">
        <!-- We can group by category later, for now flat list -->
        @for (cmd of filteredCommands(); track cmd.id; let i = $index) {
        <div
          id="cmd-item-{{ i }}"
          class="command-item p-3 border-round-md cursor-pointer flex align-items-center justify-content-between transition-colors duration-150"
          [class.selected]="i === selectedIndex()"
          (click)="selectCommand(cmd)"
          (mouseenter)="selectedIndex.set(i)">
          <div class="flex align-items-center gap-3">
            <div
              class="icon-wrapper flex align-items-center justify-content-center border-round surface-100 p-2 text-600"
              [class.text-primary]="i === selectedIndex()">
              <lucide-icon
                [name]="cmd.icon"
                [size]="18"></lucide-icon>
            </div>
            <div class="flex flex-column gap-1">
              <span class="font-medium text-900 line-height-2">{{ cmd.label }}</span>
              <span class="text-xs text-500">{{ cmd.category }}</span>
            </div>
          </div>

          <div class="flex align-items-center gap-3">
            @if (cmd.shortcut) {
            <span
              class="text-xs font-semibold surface-border border-1 border-round px-2 py-1 text-500 bg-white"
              >{{ cmd.shortcut }}</span
            >
            } @if (i === selectedIndex()) {
            <lucide-icon
              name="corner-down-left"
              class="text-500 enter-icon"
              [size]="16"></lucide-icon>
            }
          </div>
        </div>
        }
      </div>
      } @else {
      <div
        class="flex flex-column align-items-center justify-content-center p-6 text-center text-500">
        <lucide-icon
          name="command"
          [size]="32"
          class="mb-3 opacity-50"></lucide-icon>
        <span class="font-medium">Nenhum comando encontrado</span>
        <span class="text-sm mt-1">Tente buscar por "Vendas", "Produtos"...</span>
      </div>
      }
    </div>

    <!-- Footer -->
    <div
      class="footer-section p-2 surface-50 border-top-1 surface-border flex justify-content-end gap-3 text-xs text-500 px-3">
      <span class="flex align-items-center gap-1">
        <span class="bg-white border-1 surface-border border-round px-1 font-bold">↑</span>
        <span class="bg-white border-1 surface-border border-round px-1 font-bold">↓</span>
        navegar
      </span>
      <span class="flex align-items-center gap-1">
        <span class="bg-white border-1 surface-border border-round px-1 font-bold">↵</span>
        selecionar
      </span>
    </div>
  </div>
</p-dialog>
